import React from 'react';
import './OrderCardItems.less';

export const OrderCardItems = ({text}) => {
	return <span className="order-card-items">{text}</span>
}
